import { useSuspenseQuery } from '@apollo/client';
import {
  TabsContent,
  TabsItem,
  TabsList,
  TabsRoot,
} from '@synoptic/ui-kit/tabs/tabs.tsx';
import { FC, useState } from 'react';
import { gql } from '@/__generated__';
import { cardBody, formHeading } from '../../_auth/page.css.ts';
import { ChooseUsernameForm } from './choose-username-form.tsx';
import { authTabItem, authTabsList } from './choose-username.css.ts';
import { ClaimTwitterUsername } from './claim-twitter-username.tsx';

const ChooseUsernameDataQuery = gql(`
  query ChooseUsernameDataQuery {
    me {
      id
      protectedFields {
        possibleUsernames
      }
      xComHandle
    }
}
`);

export const ChooseUsername: FC<{
  onChooseUsername: (username: string) => void;
}> = ({ onChooseUsername }) => {
  const {
    data: {
      me: { xComHandle, protectedFields },
    },
  } = useSuspenseQuery(ChooseUsernameDataQuery);
  const [submitting, setSubmitting] = useState(false);

  return (
    <>
      <h1 className={formHeading}>Choose your username</h1>
      <p className={cardBody}>
        Select a username or claim your X (Twitter) handle.
      </p>
      <TabsRoot defaultValue={xComHandle ? 'claim' : 'choose'}>
        <TabsList className={authTabsList}>
          <TabsItem className={authTabItem} value={'choose'}>
            Select a username
          </TabsItem>
          <TabsItem
            className={authTabItem}
            value={'claim'}
            disabled={submitting}
          >
            Claim from X (Twitter)
          </TabsItem>
        </TabsList>
        <TabsContent value={'choose'}>
          <ChooseUsernameForm
            possibleUsernames={protectedFields?.possibleUsernames}
            onSubmittingChange={setSubmitting}
            onChooseUsername={onChooseUsername}
          />
        </TabsContent>
        <TabsContent value={'claim'}>
          <ClaimTwitterUsername
            onChooseUsername={onChooseUsername}
            xComHandle={xComHandle}
          />
        </TabsContent>
      </TabsRoot>
    </>
  );
};
